import Image from '@repo/ui/src/components/Image';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import buildLinkObj from '@repo/ui/src/functions/build-link';
import { MetaProps } from '@repo/ui/src/types/meta';
import { ImageProps, MediaType } from '@repo/ui/src/types/image';
import { Anchor } from '@repo/ui/src/components/Anchor';

interface Props {
  _meta: MetaProps;
  __typename: string;
  searchType: string;
  title: string;
  description: string;
  images: MediaType[];
  headerAsset?: ImageProps[];
  productData?: any;
  recipeMetaSection?: any;
  assets?: any[];
}

const getListData = ({
  _meta,
  __typename,
  searchType,
  recipeMetaSection,
  assets,
  title,
  description,
  images,
  headerAsset,
}: Props) => {
  let itemTitle = '';
  let itemDescription = '';
  let image = null;
  let deliveryKey = '';
  const imageWidth = 100;

  if (_meta && _meta.deliveryKey) {
    deliveryKey = _meta.deliveryKey;
  }
  if (__typename === 'RecipeListItem' || searchType === 'Recipe') {
    itemTitle = (recipeMetaSection && recipeMetaSection.title) || '';
    itemDescription = (recipeMetaSection && recipeMetaSection.description) || '';
    if (assets && assets.length > 0) {
      image = buildImageSrc(assets[0], imageWidth, 1, 1, null);
    }
  }
  if (__typename === 'MealPlanListItem') {
    return null;
  }

  if (
    searchType === 'Product' ||
    __typename === 'Product' ||
    searchType === 'Learn' ||
    __typename === 'LearningContent'
  ) {
    itemTitle = title || '';
    itemDescription = description || '';
    if (images && images.length > 0) {
      image = buildImageSrc(images[0], imageWidth, 1, 1, null);
    }
    if (headerAsset && headerAsset.length > 0 && headerAsset[0].image) {
      image = buildImageSrc(headerAsset[0].image, imageWidth, 1, 1, null);
    }
  }
  return {
    title: itemTitle,
    description: itemDescription,
    image,
    deliveryKey,
  };
};

const SearchListItem = (props: Props) => {
  const data = getListData({ ...props });
  if (!data) return null;
  const { title, description, image, deliveryKey } = data;
  const linkObj = buildLinkObj({ link: deliveryKey });

  return (
    <li role="option" aria-selected={false}>
      <Anchor className="tw-inline-block tw-w-full" link={linkObj.href}>
        <div className="md:tw-flex tw-gap-4 tw-py-6">
          {image && (
            <div className="tw-hidden md:tw-block md:tw-w-28 md:tw-h-28 tw-flex-none tw-relative">
              <Image src={image} alt={title} layout="fill" objectFit="cover" />
            </div>
          )}

          <div>
            <h2 className="tw-mb-0 tw-relative tra-text-web-heading-4 md:tra-text-web-heading-6">
              {title}
            </h2>

            {description && (
              <p className="tw-m-0 tw-mt-2 hover:color-tra-text-web-display">{description}</p>
            )}
          </div>
        </div>

        <hr className="tw-my-0" />
      </Anchor>
    </li>
  );
};

export default SearchListItem;
